import { render, staticRenderFns } from "./ProofreadingWaitingPage.vue?vue&type=template&id=1023dd66"
import script from "./ProofreadingWaitingPage.vue?vue&type=script&lang=ts"
export * from "./ProofreadingWaitingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1023dd66')) {
      api.createRecord('1023dd66', component.options)
    } else {
      api.reload('1023dd66', component.options)
    }
    module.hot.accept("./ProofreadingWaitingPage.vue?vue&type=template&id=1023dd66", function () {
      api.rerender('1023dd66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/ProofreadingWaitingPage.vue"
export default component.exports